class Dispatcher {
	constructor() {
		this.listeners = {};
		this.TYPE_REPEATED = 'TYPE_REPEATED';
		this.TYPE_ONCE = 'TYPE_ONCE';
	}
	
	addEventListener(eventName, fn, type = 'TYPE_REPEATED') {
		if (!this.listeners.hasOwnProperty(eventName))
			this.listeners[eventName] = [];
		this.removeEventListener(eventName, fn); // Just in case it already exists
		this.listeners[eventName].push({f: fn, type: type});
	}
	
	removeEventListener(eventName, fn) {
		if (!this.listeners.hasOwnProperty(eventName))
			return;
		for(let i=0; i < this.listeners[eventName].length; i++) {
			if (this.listeners[eventName][i].f === fn) {
				this.listeners[eventName].splice(i, 1);
			} else {
				//console.log("Not the function", i);
			}
		}
	}
	
	call(eventName, params) {
		let remove = [];
		if(this.listeners.hasOwnProperty(eventName))
			for(let i=0; i < this.listeners[eventName].length; i++) {
				if (this.listeners[eventName][i].type === this.TYPE_ONCE)
					remove.push(this.listeners[eventName][i].f);
				this.listeners[eventName][i].f.apply(null, params);
			}
		for(let i=0; i < remove.length; i++)
			this.removeEventListener(eventName, remove[i]);
	}
	
}

export default Dispatcher;